<template>
  <b-row class="pt-2 pb-1" v-if="field && value">
    <b-col cols="12" class="mb-2">
      <b>{{field.name}}</b>
    </b-col>
    <b-col cols="12" v-if="['TEXTAREA', 'STRING', 'ENUM', 'JOB_TITLES'].includes(field.type)">
      <a
        v-if="field.key.includes('LINKEDIN-') || field.key.includes('URL-') || field.key.includes('LINK-')"
        :href="value"
        target="_blank"
      >{{value.length > 20 ? `${value.substring(0,20)}...` : value }}</a>
      <span v-else class="text-muted">{{ value }}</span>
    </b-col>
    <b-col cols="12" v-if="['CHECKBOX'].includes(field.type)">
      <span class="text-muted">{{value ? 'Yes' : 'No'}}</span>
    </b-col>
    <job-skills-show
      class="mb-2"
      v-if="field.type === 'JOB_SKILLS'"
      name="Skills"
      :value="value"
      :backgroundColor="backgroundColour"
      hide-name
    />
    <job-skills-show
      class="mb-2"
      v-if="field.type === 'JOB_DEVELOPMENT_SKILLS'"
      name="Development Skills"
      :value="value"
      :backgroundColor="backgroundColour"
      hide-name
    />
    <languages-show
      v-if="field.type === 'LANGUAGES'"
      name="Languages"
      :value="value"
      :backgroundColor="backgroundColour"
      hide-name
    />
    <qualifications-show
      v-if="field.type === 'QUALIFICATIONS'"
      name="Qualifications"
      :value="value"
      :backgroundColor="backgroundColour"
      hide-name
    />
    <date-show
      v-if="field.type === 'DATE'"
      name="Date"
      :value="value"
      :backgroundColor="backgroundColour"
      hide-name
    />
    <job-history-show
      v-if="field.type === 'JOB_HISTORY'"
      name="Job History"
      :value="value"
      :backgroundColor="backgroundColour"
      hide-name
    />
    <location-show
      v-if="field.type === 'LOCATION'"
      name="Location"
      :value="value"
      :backgroundColor="backgroundColour"
      hide-name
    />
    <job-skills-show
      v-if="field.type === 'JOB_SENIORITY'"
      class="mb-2"
      name="Seniority"
      :value="value"
      :backgroundColor="backgroundColour"
      hide-name
    />
    <job-business-area-show
      v-if="field.type === 'JOB_BUSINESS_AREA'"
      name="Business Area"
      :value="value"
      :backgroundColor="backgroundColour"
      hide-name
    />
  </b-row>
</template>

<script>
import JobSkillsShow from '@/components/profile/JobSkillsShow';
import JobBusinessAreaShow from '@/components/profile/JobBusinessAreaShow';
import LanguagesShow from '@/components/profile/LanguagesShow';
import QualificationsShow from '@/components/profile/QualificationsShow';
import DateShow from '@/components/profile/DateShow';
import JobHistoryShow from '@/components/profile/JobHistoryShow';
import LocationShow from '@/components/profile/LocationShow';

export default {
  name: 'CustomFieldBlock',
  components: {
    JobSkillsShow, LanguagesShow, QualificationsShow, LocationShow, JobBusinessAreaShow, JobHistoryShow, DateShow
  },
  props: {
    field: {
      type: Object,
    },
    value: {
      default: null,
    },
    backgroundColour: {
      type: String,
      default: '#eee',
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/profile/CustomFieldBlock.vue